import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SessionStorage, SessionStorageService } from "ngx-webstorage";
import { SiniestralidadMensual, SiniestralidadPoliza, SiniestralidadPorTipo, ResumenSiniestralidad } from "../entities/vam_entities";

declare var jQuery: any;

@Component({
    selector: 'Resumen',
    templateUrl: 'resumengr.template.html'
})
export class ResumenGrComponent implements OnChanges, OnInit {


    Mensual: SiniestralidadMensual[];
    UsoPoliza: SiniestralidadPoliza;
    TipoAtencion: SiniestralidadPorTipo[];
    DetalleTipoAtencion: SiniestralidadPorTipo[];
    TipoPaciente: SiniestralidadPorTipo[];
    SiniestralidadAcumulada: SiniestralidadMensual;
    @Input('resumenSiniestralidadGr')
    Resumen: ResumenSiniestralidad;

    public lineChartData: Array<any>;
    public lineChartLabels: Array<any>;
    public reembolsoChartData: Array<any>;
    public numReclamosChartData: Array<any>;
    public barChartData:any[];

    public lineChartOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            yAxes: [
                {
                    id: 'yAxis1',
                    position: 'left'
                },
                {
                    id: 'yAxis2',
                    position: 'right'
                }
            ]
        }
    };
    public genChartOptions: any = {
        responsive: true,
        maintainAspectRatio: false
    };
    public lineChartLegend: boolean = true;
    public lineChartType: string = 'line';
    public barChartType:string = 'bar';
    public barChartLabels:string[] ;

    public pieChartLabels:string[];
    public pieChartData:number[];
    public pieChartType:string = 'pie';

    public lineChartColors:Array<any> = [
        { // grey
          backgroundColor: 'rgba(148,159,177,0.2)',
          borderColor: 'rgba(148,159,177,1)',
          pointBackgroundColor: 'rgba(148,159,177,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        { // dark grey
          backgroundColor: 'rgba(77,83,96,0.2)',
          borderColor: 'rgba(77,83,96,1)',
          pointBackgroundColor: 'rgba(77,83,96,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(77,83,96,1)'
        },
      ];

    constructor() {
        this.DetalleTipoAtencion = [];
        this.UsoPoliza = new SiniestralidadPoliza();
        this.SiniestralidadAcumulada = new SiniestralidadMensual();
        this.TipoPaciente = [];
        this.Mensual = [];
        this.TipoAtencion = [];
    }
    ngOnInit(): void {
        this.DetalleTipoAtencion = [];
        this.UsoPoliza = new SiniestralidadPoliza();
        this.SiniestralidadAcumulada = new SiniestralidadMensual();
        this.TipoPaciente = [];
        this.Mensual = [];
        this.TipoAtencion = [];
        this.lineChartData = new Array<any>();
        this.lineChartLabels = new Array<any>();
        this.reembolsoChartData= new Array<any>();
        this.numReclamosChartData= new Array<any>();
        this.barChartData= [];
        this.pieChartLabels=[];
        this.pieChartData=[];
    }

    ngOnChanges(): void {
        if (this.Resumen != undefined && this.Resumen != null) {
            this.DetalleTipoAtencion = this.Resumen.DetalleTipoAtencion;
            this.UsoPoliza = this.Resumen.UsoPoliza;
            this.Mensual = this.Resumen.Mensual;
            this.TipoPaciente = this.Resumen.TipoPaciente;
            this.TipoAtencion = this.Resumen.TipoAtencion;
            this.SiniestralidadAcumulada = this.Resumen.Acumulada;
            if(this.Mensual != undefined){
                let mes: Array<any>  = this.Mensual.map(data => data.Mes);
                this.lineChartLabels = mes;
                let siniestralidad: Array<any> =new Array<any>();
                for (let i = 0; i < this.Mensual.length; i++) {
                   siniestralidad.push(Math.floor((Math.random() * 100) + 1));
                }
              let reembolso : Array<any> = this.Mensual.map(data=> data.ValorReembolsado);
               this.lineChartData =[  {data: siniestralidad, label: 'Siniestralidad', yAxisID:"yAxis1"}, {data: reembolso, label: 'Valor Reembolsado Por Mes', yAxisID:"yAxis2"}];
               let siniestros  : Array<any> = this.Mensual.map(data=> data.NumeroReclamos);
               this.numReclamosChartData=[{data: siniestralidad, label: 'Siniestralidad', yAxisID:"yAxis1"},  {data: siniestros, label: 'Reclamos por Mes', yAxisID:"yAxis2"}];
            }
            
            if(this.UsoPoliza != undefined){
              this.barChartData =  [{data:[this.UsoPoliza.TitularesAsegurados] , label: 'Titulares Asegurados'},
                {data: [this.UsoPoliza.TitularesSiniestros] , label: 'Titulares que utilizaron la póliza'}];
            }
            
            if(this.TipoAtencion != undefined){
                let tipoReclamos = this.TipoAtencion.filter(d=> d.NombreTipo != "TOTAL");
                this.pieChartLabels = tipoReclamos.map(data=> data.NombreTipo);
                this.pieChartData = tipoReclamos.map(data=> data.PorcentajeReembolsado);
            }
        }

    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/polizasContratadas/resumengr.component.ts